<template>
    <v-row>
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="40%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                <v-container class="pa-2">
                    <v-row>
                        <v-col cols="5">
                            <!--<v-select
                                :items="golfCourseCode"
                                item-text="golf_name"
                                item-value="golf_code"
                                label="ゴルフ場"
                                v-model="golfCode"
                                :disabled="selectDisabled"
                                :rules="[rules.required]"
                                />
                            -->
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="3" class="text-right">
                            <v-btn
                                color="warning"
                                :disabled="btn[1].isActive || adminOnly"
                                @click="openChangeOverlay">
                                    <span v-if="completed">{{ btnName1 }}に戻す</span>
                                    <span v-else>{{ btnName2 }}</span>
                                </v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col align-self="start">
                            <span>会員</span>
                        </v-col>
                        <v-col align-self="end" class="text-right">
                            <span>ゴルフ場</span>
                        </v-col>
                    </v-row>
                </v-container>
                <v-row
                    justify="center"
                >
                    <v-list
                        ref="messageListWindow"
                        width="100%"
                        style="text-align: center"
                        class="messageListWindow">
                        <template v-if="desserts.length === 0">
                            <div>
                                メッセージがありません。
                            </div>
                        </template>
                        <template v-else>
                            <ul class="d-flex flex-column px-2 scrollXhidden" style="max-width: 99%; padding-left: 0px;">
                                <span v-for="d in desserts"
                                    :key="d.id"
                                    class="d-flex flex-column">
                                    <small v-if="d.day.dispFlag" class="mx-auto my-2">{{ d.day.day }}</small>
                                    <li
                                        style="max-width: 70%;"
                                        class="card my-1 text-left"
                                        :class="{
                                            'says': !d.send_id,
                                            'mycomment': d.send_id,
                                            'align-self-end': d.send_id,
                                            'align-self-start': !d.send_id,
                                        }"
                                    >
                                        <div>
                                            <div class="content text-justify">{{ d.message }}</div>
                                        </div>
                                        <small>
                                            <p
                                                :class="{
                                                    'small-mycomment-times': d.send_id,
                                                    'small-says-times': !d.send_id
                                                }"
                                            >{{ d.day.time }}</p>
                                        </small>
                                    </li>
                                </span>
                            </ul>
                        </template>
                    </v-list>
                </v-row>
                <div class="admin-gray-border-bottom"></div>
                <v-container>
                    <v-row>
                        <v-col cols="12" class="inputArea">
                            <v-textarea
                                v-model="inputMessage"
                                placeholder="メッセージを入力してください"
                                rows="5"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions class="py-0">
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="closeModal">閉じる</v-btn>
                    <v-btn
                        :disabled="btn[2].isActive"
                        color="green darken-4"
                        text
                        @click="postMessage">登録</v-btn>
                </v-card-actions>
            </v-card>
            <changeOverLay
                page-name="対応ステータス"
                @processing="updateComplete"
                @cancel="closeChangeOverlay"
                :process-result="process"
                :OverlaySwitch="changeOverLay"
            />
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
// mixins
import { utilityMixin } from '@/mixins/utility';
// graghql
import {
    GET_CONTACT_MESSAGE_LIST_BY_MEMBER_NO,
    GET_CONTACT_MESSAGE_LIST_BY_RESERVE_NO,
    UPDATE_COMPLETE,
    POST_MESSAGE_ADMIN,
    SEND_INQUIRY_NOTICE_EMAIL } from '@/constants/contact';
import changeOverLay from '@/components/overlay/ChangeOverlay';

export default {
    components: {
        CardTitle,
        changeOverLay
    },
    props: [
        'adminInfo',
        'golfCourseSelection',
        'detailInfo',
        'received',
        'code'
    ],
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            dialog: false,
            inputDialog: false,
            changeOverLay: false,
            page_title: 'メッセージ確認',
            // 現在ログインしているメンバーID
            memberNo: '',
            // 予約番号
            reserveNo: '',
            // キャンセル時に使用するID
            cancelData: {
                id: ''
            },
            // 子コンポーネントに渡す処理
            passTo: {
                admin: {
                    user_name: '',
                    user_div: '',
                    user_id: ''
                },
                memberNo: '',
                reserveNo: '',
                golfCode: ''
            },
            // 処理の結果のオブジェクト
            process: {
                result: '',
                resultText: '',
                btnDisabled: 0
            },
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            golfCode: '',
            searchGolfCode: '',
            // ゴルフ場情報
            golfCourseCode: [],
            // メッセージ情報
            desserts: [],
            // メッセージ
            message: '',
            inputMessage: '',
            // プラン名
            planName: '',
            // 対応完了フラグ
            completed: true,
            completedCd: 1,
            notReserves: '000000000000',
            rules: {
                required: value => !!value || this.$t('error.validation.required.any')
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '対応完了', isActive: true },
                { element_id: '002', element_name: 'メッセージ入力', isActive: true },
                { element_id: '002', element_name: '登録追加', isActive: true }
            ],
            vue_id: 'SCR0020',
            btnName1: '',
            btnName2: '',
            adminOnly: true
        };
    },
    async created () {
    },
    watch: {
        golfCode () {
            if (this.golfCode) {
                this.getContactMessgaeList();
            }
        },
        desserts: function (desserts) {
            this.$nextTick(function () {
                var container = this.$refs.messageListWindow.$el;
                container.scrollTop = container.scrollHeight;
            });
        }
    },
    computed: {
        // 親からの予約番号が空のときfalse,空ではないときtrue
        selectDisabled () {
            return this.reserveNo !== '' &&
                   this.reserveNo !== process.env.VUE_APP_ADMIN_GOLF_CODE;
        }
    },
    methods: {
        /** ----------------------------------------------
         * メッセージ一覧を取得
         * ---------------------------------------------- */
        async getContactMessgaeList () {
            if (!this.reserveNo) {
                this.$apollo.mutate({
                    mutation: GET_CONTACT_MESSAGE_LIST_BY_MEMBER_NO,
                    fetchPolicy: 'no-cache',
                    variables: {
                        golf_group_code: this.golfGroupCode,
                        golf_code: this.golfCode,
                        member_no: this.memberNo,
                        reserve_no: this.notReserves,
                        user_id: this.userId,
                        vue_id: this.vue_id,
                        element_id: ''
                    }
                }).then(res => {
                    // コードマスタより対応完了フラグの名称を取得
                    this.codeList = this.code;
                    this.btnName1 = this.codeList[1].code_name;
                    this.btnName2 = this.codeList[2].code_name;
                    const message = res.data.getContactsMessageListAdmin.Message;
                    let opeList = res.data.getContactsMessageListAdmin.OperationAccessList;
                    this.OperationAccessList(opeList);
                    this.MakeMessageList(message);
                    this.checkTheInquiryCompleted(message);
                    this.checkAdminMessageOnly(message);
                }).catch(error => {
                    this.$set(this.process, 'resultText', error);
                });
            } else {
                this.$apollo.mutate({
                    mutation: GET_CONTACT_MESSAGE_LIST_BY_RESERVE_NO,
                    fetchPolicy: 'no-cache',
                    variables: {
                        golf_group_code: this.golfGroupCode,
                        golf_code: this.golfCode,
                        reserve_no: this.reserveNo,
                        user_id: this.userId,
                        vue_id: this.vue_id,
                        element_id: ''
                    }
                }).then(res => {
                    // コードマスタより対応完了フラグの名称を取得
                    this.codeList = this.code;
                    this.btnName1 = this.codeList[1].code_name;
                    this.btnName2 = this.codeList[2].code_name;
                    const message = res.data.getContactsMessageListByReserveNoAdmin.Message;
                    let opeList = res.data.getContactsMessageListByReserveNoAdmin.OperationAccessList;
                    this.OperationAccessList(opeList);
                    this.MakeMessageList(message);
                    this.checkTheInquiryCompleted(message);
                    this.checkAdminMessageOnly(message);
                }).catch(error => {
                    this.$set(this.process, 'resultText', error);
                });
            }
        },
        /** ----------------------------------------------
         * メッセージ一覧作成
         * ---------------------------------------------- */
        MakeMessageList: function (messageList) {
            this.desserts.splice(0, this.desserts.length);
            var monitorDateList = [];
            for (let message of messageList) {
                var substrDate = message.created_at.substr(0, 10);
                var substrTimr = message.created_at.substr(-8);
                var splitDate = substrDate.split('-');
                var splitTime = substrTimr.split(':');
                var year = splitDate[0];
                var month = splitDate[1];
                var day = splitDate[2];
                var dateObj = new Date(Number(year), Number(month) - 1, Number(day));
                var JpStrDate = this.getDateBindStrJapanese(dateObj);
                var judgeDay = this.getDayJapanese(dateObj);
                var pushDay = {};
                if (monitorDateList.includes(JpStrDate)) {
                    pushDay = {
                        day: JpStrDate + '(' + judgeDay + ')',
                        time: splitTime[0] + ':' + splitTime[1],
                        dispFlag: false
                    };
                } else {
                    pushDay = {
                        day: JpStrDate + '(' + judgeDay + ')',
                        time: splitTime[0] + ':' + splitTime[1],
                        dispFlag: true
                    };
                }
                monitorDateList.push(JpStrDate);
                this.desserts.push({
                    completed: message.completed,
                    day: pushDay,
                    id: message.id,
                    message: message.message,
                    send_id: message.send_id
                });
            }
        },
        /** ----------------------------------------------
         * 権限リストからボタンの活性状態を変更
         * ---------------------------------------------- */
        OperationAccessList (opeList) {
            for (let list of opeList) {
                this.btn.forEach(el => {
                    if (list.element_id === el.element_id) {
                        if (list.element_control === 0) {
                            el.isActive = true;
                        } else {
                            el.isActive = false;
                        }
                    }
                });
            };
        },
        /** ----------------------------------------------
         * 対応完了処理
         * ---------------------------------------------- */
        async updateComplete () {
            var reserveNo = null;
            if (!this.reserveNo) {
                reserveNo = this.notReserves;
            } else {
                reserveNo = this.reserveNo;
            }
            if (this.completed) {
                this.completedCd = 1;
            } else {
                this.completedCd = 9;
            }
            await this.$apollo.mutate({
                mutation: UPDATE_COMPLETE,
                variables: {
                    reserve_no: reserveNo,
                    member_no: this.memberNo,
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCode,
                    completed: this.completedCd
                }
            }).then(res => {
                const result = res.data.updateComplete.result;
                this.$store.dispatch('auth/getMessageCount');
                this.$store.subscribe((mutation, state) => {
                    if (mutation.type === 'auth/setMessageCount') {
                        this.messageCount = this.$store.state.auth.messageCount;
                    }
                });
                if (this.completedCd === 9) {
                    this.completed = true;
                } else {
                    this.completed = false;
                }
                if (result !== 0) {
                    this.closeChangeOverlay();
                    const message = res.data.updateComplete.Message;
                    this.MakeMessageList(message);
                    this.checkTheInquiryCompleted(message);
                    this.checkAdminMessageOnly(message);
                } else {
                    throw new Error('既に対応完了しています。');
                }
            }).catch(error => {
                this.error = error;
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', '既に対応完了しています。');
            });
        },
        /** ----------------------------------------------
         * メンバーのメッセージが対応完了しているかチェックする
         * @messageList 画面上に表示されるメッセージの配列
         * ---------------------------------------------- */
        checkTheInquiryCompleted (messageList) {
            // 相手の最後のメッセージを取得
            if (messageList[0].completed === 9) {
                this.completed = true;
            } else {
                this.completed = false;
            }
        },
        /** ----------------------------------------------
         * 管理者だけのメッセージなのか確認
         * @messageList 画面上に表示されるメッセージの配列
         * ---------------------------------------------- */
        checkAdminMessageOnly: function (messageList) {
            // メッセージ自体がなければ
            if (!messageList) {
                this.adminOnly = true;
            } else {
                this.adminOnly = false;
            }
        },
        /** ----------------------------------------------
         * メッセージ確認画面を表示させる処理
         * ---------------------------------------------- */
        ModalControl (reveivedMemberNo) {
            this.memberNo = reveivedMemberNo;
            this.dialog = true;

            if (this.adminInfo.user_div === 1 && this.adminInfo.point_use_type === 1) {
                this.golfCourseCode = this.golfCourseSelection.filter(el => el.golf_code !== '');
            } else {
                this.golfCourseCode = this.golfCourseSelection;
            }

            if (this.received) {
                if (this.received.reserve_no) {
                    this.reserveNo = this.received.reserve_no;
                }
                if (this.received.golfCode) {
                    this.golfCode = this.received.golfCode;
                }
            } else {
                this.golfCode = this.golfCourseCode[0].golf_code;
            }
            this.userId = this.adminInfo.user_id;
        },
        /** ----------------------------------------------
         * メッセージ確認画面を閉じるときの処理
         * ---------------------------------------------- */
        closeModal () {
            this.desserts.splice(0, this.desserts.length);
            this.golfCode = '';
            this.dialog = false;
            this.completed = false;
            this.adminOnly = true;
            this.$emit('refresh-event');
        },
        /** ----------------------------------------------
         * メッセージ登録画面を表示させる処理
         * ---------------------------------------------- */
        openChildModal () {
            this.passTo.memberNo = this.memberNo;
            this.passTo.golfCode = this.golfCode;
            this.passTo.admin.user_name = this.adminInfo.user_name;
            this.passTo.admin.user_div = this.adminInfo.user_div;
            this.passTo.admin.user_id = this.adminInfo.user_id;
            if (this.received) {
                this.passTo.reserveNo = this.received.reserve_no;
            }
            this.inputDialog = true;
        },
        /** ----------------------------------------------
         * メッセージ登録画面を閉じる処理
         * ---------------------------------------------- */
        closeChildModal () {
            this.getContactMessgaeList();
            this.inputDialog = false;
        },
        /** ----------------------------------------------
         * 確認ダイアログの表示処理
         * ---------------------------------------------- */
        openChangeOverlay () {
            this.changeOverLay = true;
        },
        /** ----------------------------------------------
         * 確認ダイアログの閉じる処理
         * ---------------------------------------------- */
        closeChangeOverlay () {
            this.$set(this.process, 'result', '');
            this.changeOverLay = false;
        },
        /** ----------------------------------------------
         * メッセージを送信する
         * ---------------------------------------------- */
        async postMessage () {
            // 空なら返却
            if (this.inputMessage === '') return;
            if (!this.received.reserveNo) this.received.reserveNo = this.notReserves;
            await this.$apollo.mutate({
                mutation: POST_MESSAGE_ADMIN,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCode,
                    member_no: this.memberNo,
                    reserve_no: this.received.reserveNo,
                    send_id: this.adminInfo.user_id,
                    message: this.inputMessage,
                    completed: 1,
                    family_name: null,
                    given_name: null
                }
            }).then(res => {
                const result = res.data.postMessageAdmin.result;
                if (result === 1) {
                    const message = res.data.postMessageAdmin.Message;
                    this.MakeMessageList(message);
                    this.checkTheInquiryCompleted(message);
                    this.checkAdminMessageOnly(message);
                    this.$store.dispatch('auth/getMessageCount');
                    this.$store.subscribe((mutation, state) => {
                        if (mutation.type === 'auth/setMessageCount') {
                            this.messageCount = this.$store.state.auth.messageCount;
                        }
                    });
                } else if (result === 0) {
                    throw res.data.errorMessage;
                }
            }).catch(error => {
                this.$set(this.process, 'resultText', error);
            });
            this.inputMessage = '';
        },
        /** ----------------------------------------------
         * 投稿完了通知メールを送信する
         * ---------------------------------------------- */
        SendNoticeEmail () {
            try {
                this.$apollo.mutate({
                    mutation: SEND_INQUIRY_NOTICE_EMAIL,
                    variables: {
                        reserve_no: this.received.memberNo,
                        golf_group_code: this.golfGroupCode,
                        golf_code: this.golfCode,
                        member_no: this.memberNo,
                        family_name: null,
                        given_name: null
                    }
                });
            } catch (error) {
                this.error = error;
            }
        }
    }
};

</script>

<style scoped>
    .messageListWindow{
        overflow-y: scroll;
        height: calc(100vh - 445px);
    }
    .contact-message-body{
        background-color: #ffffff;
        margin-bottom: 15px;
    }
    .content {
        white-space: pre-wrap;
    }
    .contact-message-body.scrollY {
        max-height: 400px;
        min-height: 300px;
    }
    .says {
        display: inline-block;
        position: relative;
        margin: 0px 0px 0px 10px;
        padding: 8px;
        max-width: 250px;
        border-radius: 12px;
        background: #F0F0F0;
        border: none;
    }
    .says:after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 3px;
        left: -19px;
        border: 8px solid transparent;
        border-right: 18px solid #F0F0F0;
        -webkit-transform: rotate(35deg);
        transform: rotate(35deg);
    }
    .says p {
        margin: 0;
        padding: 0;
    }
    .mycomment {
        margin: 10px 0;
    }
    .v-application p {
        margin-bottom: 0px;
    }
    .mycomment {
        /* display: inline-block;
        position: relative;
        margin: 0 10px 0 0;
        padding: 8px;
        max-width: 250px;
        border-radius: 12px;
        background:  #dcf5f4;
        font-size: 15px;
        border: none; */

        display: inline-block;
        position: relative;
        padding: 8px;
        max-width: 250px;
        background:  #dcf5f4;
        border-radius: 12px;
        border: none;
    }
    .mycomment:after {
        content: "";
        position: absolute;
        top: 3px;
        right: -19px;
        border: 8px solid transparent;
        border-left: 18px solid #dcf5f4;
        -webkit-transform: rotate(-35deg);
        transform: rotate(-35deg);
    }
    .inputArea {
        padding: 0;
    }
    .admin-gray-border-bottom {
        border-bottom: 1px solid#e8e8e8;
    }
    .small-mycomment-times{
        position: absolute;
        bottom: 0px;
        left: -35px;
    }
    .small-says-times{
        position: absolute;
        bottom: 0px;
        right: -35px;
    }
    .scrollXhidden{
        overflow-x: hidden;
    }
    .v-dialog__content {
        justify-content: end !important;
    }
</style>
